<template>
  <div class="a-overlay" :class="{'a-hidden':!show}" @click="onClickOverlay" @touchmove.prevent>
    <div class="a-fix-bottom" :class="{'a-hidden':!show}" @click.stop>
      <div class="a-picker-header">
        <div class="a-picker-header-btn a-gray" @click="onClickCancel">取消</div>
        <div class="a-picker-header-btn a-primary" @click="onClickConfirm">确认</div>
      </div>
      <picker-view
        :ranges="ranges" :rkey="rkey" :value="value" :force="force"
        @columnchange="handleColumnChange"
        @touchstart="handleTouchstart"></picker-view>
    </div>
  </div>
</template>

<script>
  import PickerView from './picker-view';

  export default {
    components: {
      'picker-view': PickerView
    },

    props: {
      show: Boolean,
      ranges: Array,
      rkey: String,
      value: Array,
      // 如果只传入同样的value并不会更新，传另一个值给强制刷新
      force: Array,
      callback: {
        type: Function,
        default: () => {}
      },
      onColumnChange: {
        type: Function,
        default: () => {}
      },
      onTouchstart: {
        type: Function,
        default: () => {}
      }
    },

    watch: {
      value(v) {
        this.__rvalue = v.slice();
      }
    },

    created() {
      this.__rvalue = this.value.slice();
    },

    methods: {
      onClickOverlay() {
        this.callback('cancel');
      },

      onClickCancel() {
        this.callback('cancel');
      },

      onClickConfirm() {
        this.callback('confirm', this.__rvalue);
      },

      handleColumnChange(e) {
        const { column, value } = e.detail;
        this.__rvalue[column] = value;
        this.onColumnChange(column, value);
      },

      handleTouchstart(e) {
        const { column } = e.detail;
        this.onTouchstart(column);
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "../../../scss/_vars.scss";

  .a-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fafafa;
  }
  .a-picker-header-btn {
    font-size: 18*$px;
    padding: 6*$px 20*$px;
  }
</style>



// WEBPACK FOOTER //
// src/ui/base/components/picker.vue